module.exports = __webpack_public_path__ + "img/06.c241e770.jpg";